import React from "react";

import { Route, Switch } from "react-router-dom";

import Login from "./views/Login";
import Edit from "./views/Edit";
import Settings from "./views/Settings";
import UsersOverview from "./views/UsersOverview";
import UserEdit from "./views/UserEdit";

import Protect from "./components/Protect";

const App: React.FC = () => {
  return (
    <>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/settings">
          <Protect>
            <Settings />
          </Protect>
        </Route>
        <Route exact path="/users">
          <Protect>
            <UsersOverview />
          </Protect>
        </Route>
        <Route exact path="/users/add">
          <Protect>
            <UserEdit create />
          </Protect>
        </Route>
        <Route exact path="/users/:id">
          <Protect>
            <UserEdit />
          </Protect>
        </Route>
        <Route path="/">
          <Protect>
            <Edit />
          </Protect>
        </Route>
      </Switch>
    </>
  );
};

export default App;
